import { CONTENT_ALIAS } from './const.config';

// Define page-title configurations
const PAGE_TITLE_LIST = {
  OVERVIEW_DASHBOARD: 'Overview Dashboard',
  SUBSCRIBERS: 'Subscribers',
  ADMIN_USERS: 'CMS Users',
  CONTENT_CHANNELS: `Content / ${CONTENT_ALIAS.CHANNEL_PLURAL}`,
  CONTENT_CATEGORY: `Content / ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  CONTENT_SERIES: `Content / ${CONTENT_ALIAS.SERIES_PLURAL}`,
  CONTENT_SERIES_SEASONS: 'Content / Seasons',
  CONTENT_SHOWS: `Content / ${CONTENT_ALIAS.SHOW_PLURAL}`,
  CONTENT_VIDEOS: `Content / ${CONTENT_ALIAS.VIDEO_PLURAL}`,
  CONTENT_SEQUENCE: 'Content / Sequence',
  CONTENT_TABS: 'Content / Tabs',
  REPORTS_APP_SESSIONS: 'Analytics Reports / App Sessions',
  LOGIN: 'Login',
  LOGOUT: 'Logout',
  ERROR_NOT_FOUND: '404 Not Found',
};

export default PAGE_TITLE_LIST;
